import { defaultSliderValue } from '../vuex/default_values';
module.exports = {
	methods: {
		searchSubmit: function(){
			var obj = this.checked;

			var ds = defaultSliderValue();
			var dsArea = ds.area.split(';');
			var dsHeight = ds.height.split(';');
			var dsPrice = ds.price.split(';');

			var queryArray = [];
			var conditionArr = [];

			var checkedStrArr = [];
			checkedStrArr = checkedStrArr.concat(this.district, this.situation, this.facility, this.service);
			var areaCode = this.areaCode;

			for (var prop in obj){
				// query
				if (obj[prop] !== 0 && obj[prop] !== false){
					if (prop === 'sm'){
						// checked.sm === 2 は0とみなし無視
						if (obj[prop] !== 2){
							queryArray.push(prop + ':' + obj[prop]);
						}
					} else if (prop === 'ssmo'){
						if (obj[prop] !== Number(dsArea[1])){
							queryArray.push(prop + ':' + obj[prop]);
						}
					} else if (prop === 'ssho'){
						if (obj[prop] !== Number(dsHeight[1])){
							queryArray.push(prop + ':' + obj[prop]);
						}
					} else if (prop === 'spo'){
						if (obj[prop] !== Number(dsPrice[1])){
							queryArray.push(prop + ':' + obj[prop]);
						}
					} else if (obj[prop] === true){
						// 値がtrueなら1とする
						queryArray.push(prop + ':' + Number(true));
					} else {
						queryArray.push(prop + ':' + obj[prop]);
					}
				};

				// condition
				if (obj[prop] !== 0 && obj[prop] !== false){
					switch (prop) {
					case 'sm':
						if (obj['sm'] === 0){
							conditionArr.push('スチール');
						} else if (obj['sm'] === 1){
							conditionArr.push('ムービー');
						}
						break;
					case 'p_st':
						if (obj['p_st'] === 1){
							conditionArr.push('ホリゾントスタジオ');
						} else if (obj['p_st'] === 2){
							conditionArr.push('ハウススタジオ');
						}
						break;
					case 'ssmu':
						if (obj['ssmu'] !== Number(dsArea[0])){
							conditionArr.push(obj['ssmu'] + '㎡以上');
						}
						break;
					case 'ssmo':
						if (obj['ssmo'] !== Number(dsArea[1])){
							conditionArr.push(obj['ssmo'] + '㎡以下');
						}
						break;
					case 'sshu':
						if (obj['sshu'] !== Number(dsHeight[0])){
							conditionArr.push(obj['sshu'] + 'm以上');
						}
						break;
					case 'ssho':
						if (obj['ssho'] !== Number(dsHeight[1])){
							conditionArr.push(obj['ssho'] + 'm以下');
						}
						break;
					case 'spu':
						if (obj['spu'] !== Number(dsPrice[0])){
							conditionArr.push(obj['spu'] + '円以上');
						}
						break;
					case 'spo':
						if (obj['spo'] !== Number(dsPrice[1])){
							conditionArr.push(obj['spo'] + '円以下');
						}
						break;
					}
					// prefectures
					for (var i = 0; i < areaCode.length; i++){
						if (prop === 'sa' + areaCode[i]){
							conditionArr.push(this.getPrefectures(areaCode[i]));
						}
					}
					// checkbox
					for (var item in checkedStrArr){
						if (prop === checkedStrArr[item].id){
							conditionArr.push(checkedStrArr[item].name);
						}
					}
				}
			};

			// イメージ検索
			var ciObj = this.checkedImage;
			var checkedImageStrArr = [];
			checkedImageStrArr = checkedImageStrArr.concat(this.images);
			// console.log(checkedImageStrArr);

			for (var ciProp in ciObj){
				if (ciObj[ciProp] !== 0){
					// query
					queryArray.push(ciProp + ':' + ciObj[ciProp]);

					// condition
					for (var ciItem in checkedImageStrArr){
						if (ciProp === checkedImageStrArr[ciItem].id){
							conditionArr.push(checkedImageStrArr[ciItem].name);
						}
					}
				}
			}

			// console.log(queryArray);
			// console.log(conditionArr);

			this.updateSearchConditions(queryArray.join('/'));
			var keywords = this.w;
			var conditions = this.c;

			conditionArr.unshift(keywords);
			this.setSCStr(conditionArr.join('&emsp;'));

			// search result
			this.$route.router.go({
				name: 'searchresult',
				query: {
					w: keywords,
					c: conditions
				}
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/mixins/searchSubmit.js